<template>
	<p>
		<ckeditor v-model="note" :editor="editor" :config="editorConfig"></ckeditor>
	</p>
</template>

<style>
.ck.ck-reset {
	color: #333;
}
</style>

<script>

// CKEditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import BlockQuotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import ListPlugin from '@ckeditor/ckeditor5-list/src/liststyle';

export default {
	name: 'TextEditor',
	props: ['item'],
	data: () => ({
		paragraphs: 0,
		words: 0,
		characters: 0,
		editor: ClassicEditor,
		editorConfig: {
			plugins: [
				EssentialsPlugin,
				BoldPlugin,
				ItalicPlugin,
				LinkPlugin,
				UnderlinePlugin,
				ParagraphPlugin,
				BlockQuotePlugin,
				AlignmentPlugin,
				ListPlugin,
			],
			alignment: {
				options: [ 'left', 'right', 'center', 'justify' ]
			},
			toolbar: [
				'undo', 'redo', '|',
				'bold', 'italic', 'underline', '|',
				'alignment', 'bulletedList', 'numberedList', '|',
				'link', 'blockQuote'
			],
		},
	}),
	computed: {
		note: {
			get() {
				return this.item.note;
			},
			set(val) {
				this.item.setNote(val);
			},
		},
	}
}

</script>
